import Phaser from "phaser";
import { FXTheme, getTheme } from "../data/FXThemes";

export class FXSystem {
  private scene: Phaser.Scene;
  private theme: FXTheme;

  constructor(scene: Phaser.Scene, themeId: string, isBoost: boolean) {
    this.scene = scene;
    this.theme = isBoost ? getTheme("boost") : getTheme(themeId);
  }

  getTheme(): FXTheme {
    return this.theme;
  }

  playHitEffect(x: number, y: number, addScore: number): void {
    // Score popup
    const text = this.scene.add
      .text(x, y - 20, `+${addScore}`, {
        fontFamily: "monospace",
        fontSize: "22px",
        color: `#${this.theme.hitColor.toString(16).padStart(6, "0")}`,
        fontStyle: "bold",
      })
      .setOrigin(0.5)
      .setDepth(250);

    this.scene.tweens.add({
      targets: text,
      y: y - 60,
      alpha: 0,
      duration: 600,
      onComplete: () => text.destroy(),
    });

    // Simple particle burst (circles)
    for (let i = 0; i < this.theme.particleCount; i++) {
      const angle = (Math.PI * 2 * i) / this.theme.particleCount;
      const px = x + Math.cos(angle) * 5;
      const py = y + Math.sin(angle) * 5;
      const particle = this.scene.add
        .circle(px, py, 3, this.theme.trailColor)
        .setDepth(240);

      this.scene.tweens.add({
        targets: particle,
        x: px + Math.cos(angle) * 40,
        y: py + Math.sin(angle) * 40,
        alpha: 0,
        scale: 0.2,
        duration: 400,
        onComplete: () => particle.destroy(),
      });
    }
  }
}
